import { faPen, faSpinner } from "@fortawesome/pro-regular-svg-icons";

import { Label } from "src/base-components/Label";
import { WorkspaceDataplane } from "src/clients/flow-api";
import { Icon } from "src/design-system/Icon";
import { ModelDropzoneController as ModelUploadController } from "src/mlNode/ModelUploadController";

type ModelFileProps = {
  modelName: string;
  onFileSelect: (file: File) => void;
  isUploading: boolean;
  workspace: WorkspaceDataplane;
};

export const ModelFile: React.FC<ModelFileProps> = ({
  modelName,
  onFileSelect,
  isUploading,
  workspace,
}) => {
  return (
    <div className="mb-4" data-loc="model-file">
      <Label required>Model File</Label>
      <div className="flex w-full items-center justify-between rounded-lg border border-gray-300 py-2.5 pr-3.5 pl-4">
        <span className="font-inter-normal-13px text-gray-800">
          {modelName}
        </span>
        <ModelUploadController
          disabled={isUploading}
          workspace={workspace}
          onFileSelect={onFileSelect}
        >
          <Icon
            icon={isUploading ? faSpinner : faPen}
            size="xs"
            spin={isUploading}
          />
        </ModelUploadController>
      </div>
    </div>
  );
};
